import type { ListOfferBypassRegionFilterSettingsQuery } from '~/services/PromoService';

export const offerBypassRegionFilterQueryKeys = {
  all: ['offer-bypass-region-filter-settings'] as const,
  lists: () => [...offerBypassRegionFilterQueryKeys.all, 'list'] as const,
  list: (filters: ListOfferBypassRegionFilterSettingsQuery) =>
    [...offerBypassRegionFilterQueryKeys.lists(), filters] as const,
  detail: (id: string) => [...offerBypassRegionFilterQueryKeys.all, 'detail', id] as const,
};
